import { handleListProductInViewport } from '@/scripts/datalayer'

export const setupPrevNextBtns = (prevBtn, nextBtn, embla) => {
  prevBtn.addEventListener('click', () => {
    embla.scrollPrev()
    handleListProductInViewport()
  }, false);
  nextBtn.addEventListener('click', () => {
    embla.scrollNext()
    handleListProductInViewport()
  }, false);
};

export const disablePrevNextBtns = (prevBtn, nextBtn, embla) => {
  return () => {
    if (embla.canScrollPrev()) prevBtn.removeAttribute('disabled');
    else prevBtn.setAttribute('disabled', 'disabled');

    if (embla.canScrollNext()) nextBtn.removeAttribute('disabled');
    else nextBtn.setAttribute('disabled', 'disabled');
  };
};

export const addNextPrevBtn = (prevBtn, nextBtn, carousel) => {
  const disablePrevAndNextBtns = disablePrevNextBtns(prevBtn, nextBtn, carousel)
  setupPrevNextBtns(prevBtn, nextBtn, carousel)
  carousel.on('select', disablePrevAndNextBtns)
  carousel.on('init', disablePrevAndNextBtns)
}
